import { queryOptions } from "@tanstack/react-query";
import { getAdminCustomerById, getAdminCustomers } from "../apis/userApi";

export const manageAdminCustomersQueryOptions = () => {
  return queryOptions({
    queryKey: ["adminCustomers"],
    queryFn: getAdminCustomers,
  });
};

export const manageAdminCustomerQueryOptions = (id: string | null) => {
  return queryOptions({
    queryKey: ["adminCustomer", id],
    queryFn: () => getAdminCustomerById(id as string),
    enabled: !!id,
  });
};
